import { render, staticRenderFns } from "./ScholarshipOverview.vue?vue&type=template&id=7c09ec10&scoped=true&"
import script from "./ScholarshipOverview.vue?vue&type=script&lang=js&"
export * from "./ScholarshipOverview.vue?vue&type=script&lang=js&"
import style0 from "./ScholarshipOverview.vue?vue&type=style&index=0&id=7c09ec10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09ec10",
  null
  
)

export default component.exports